<template>
  <router-view />
  <HeaderView v-if="authStore.isAuthenticated" />
</template>

<script>
import { useAuthStore } from '@/stores'
import HeaderView from '@/views/HeaderView.vue'

export default {
  components: { HeaderView },
  setup() {
    const authStore = useAuthStore()
    return { authStore }
  }
}
</script>

<style>
/* Global styles are now in src/styles/design-system.css */
</style>
